import axios from "axios";

export const API_ROOT = "https://api.oohtech.ng/api/services/app";

export function createClient(token) {
  const config = { baseURL: API_ROOT };
  if (token) {
    config.headers = { Authorization: `Bearer ${token}` };
  }
  return axios.create(config);
}

export async function getItems(client, endpoint) {
  if (client && typeof client.get === "function") {
    const res = await client.get(endpoint);
    return res?.data?.result?.items || [];
  }

  const normalizedEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  const url = `${API_ROOT}${normalizedEndpoint}`;
  const res = await axios.get(url);
  return res?.data?.result?.items || [];
}

export async function getLoginInfo(token) {
  const reqConfig = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  const res = await axios.get(
    "https://api.oohtech.ng/api/services/app/Session/GetCurrentLoginInformations",
    reqConfig
  );
  return res?.data?.result || {};
}

export async function login(username, password) {
  const res = await axios.post("https://api.oohtech.ng/api/TokenAuth/Authenticate", {
    usernameoremailaddress: username,
    password,
  });
  return res?.data?.result?.accessToken;
}
